import * as styles from "./EMSSection.module.css";

import { HtmlOutput } from "@components/html";
import React from "react";
import { StaticImage } from "gatsby-plugin-image";

/**
 * Renders a section with information about EMS app and links to download it.
 *
 * @param {{ emsTitle: string, emsContent: string, emsIOSLink: string, emsAndroidLink: string }} props
 * The props object containing the title, content and download links for the EMS section.
 * @returns {JSX.Element} The rendered section with the EMS information and download links.
 */
const EMSSection = ({
  emsTitle,
  emsContent,
  emsIOSLink,
  emsAndroidLink,
}: {
  emsTitle: string;
  emsContent: string;
  emsIOSLink: string;
  emsAndroidLink: string;
}) => {
  return (
    <section id="emsSection" className={`inner ${styles.emsContainer}`}>
      <div className={styles.emsInfo}>
        {/* Title and content of the section */}
        <h2 className={styles.emsInfoHeader}>{emsTitle}</h2>
        <HtmlOutput html={emsContent} />

        {/* Download link for IOS */}
        <a
          href={emsIOSLink}
          target="_blank"
          rel="nopener noreferrer"
          title="Download EMS for IOS"
        >
          <StaticImage
            src="../../../../../../../images/apple-ios-icon-with-available-on-the-app-store-text.png"
            alt="Apple IOS icon with 'available on the app store' text"
            width={160}
          />
        </a>

        {/* Download link for Android */}
        <a
          href={emsAndroidLink}
          target="_blank"
          rel="nopener noreferrer"
          title="Download EMS for Android"
        >
          <StaticImage
            src="../../../../../../../images/google-play-icon-with-get-it-on-google-play-text.png"
            alt="Google Play icon with 'get it on Google Play' text"
            width={160}
          />
        </a>
      </div>

      {/* Image displaying EMS on a phone */}
      <div className={styles.emsPhoneImgContainer}>
        <StaticImage
          src="../../../../../../../images/three-mobile-phones-displaying-different-screens-on-rightio-ems-app.png"
          alt="three mobile phones displaying different screens on rightio ems app"
        />
      </div>
    </section>
  );
};

export default EMSSection;
